export default function USPs() {
  const usps = [
    { icon: 'ri-phone-line', title: 'Free Call Outs' },
    { icon: 'ri-time-line', title: 'Same Day Service' },
    { icon: 'ri-award-line', title: '15+ Years Experience' },
    { icon: 'ri-shield-check-line', title: 'Lifetime Guarantee' },
    { icon: 'ri-price-tag-3-line', title: 'Upfront Pricing' },
  ];

  return (
    <section className="bg-[#535669] py-6 md:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:flex lg:flex-wrap lg:items-center lg:justify-center gap-x-4 gap-y-4 md:gap-x-12 md:gap-y-6">
          {usps.map((usp, index) => (
            <div key={index} className="flex items-center gap-2 md:gap-3 group">
              <div className="w-9 h-9 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-[#f67f19] shadow-lg flex-shrink-0">
                <i className={`${usp.icon} text-white text-base md:text-xl`}></i>
              </div>
              <span className="text-white font-bold text-xs md:text-base whitespace-nowrap tracking-wide">
                {usp.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}